import { IApplicationContext } from '../../../ApplicationContext';

export async function GetOpUsedAgents(appContext:IApplicationContext, JobNames:string, jobId:number) {
  let agent2:number = 0;
  let agent2Name = null;
  let agent3:number = 0;
  let agent3Name = null;

  const apiResult = await appContext.api.getUsedAgents(JobNames, jobId); 
  if (apiResult && apiResult.success) {

    if (apiResult.result.length >= 1) {
      agent2 = parseInt(apiResult.result[0].intValue);
      agent2Name = apiResult.result[0].text;
    }
    if (apiResult.result.length >= 2) {
      agent3 = parseInt(apiResult.result[1].intValue);
      agent3Name = apiResult.result[1].text;
      }
  }

  return { agent2, agent2Name, agent3, agent3Name };
}
  